import { useState, useEffect } from 'react';
import { Formik, Form, ErrorMessage } from 'formik';
// import { RolePermissionsSchema } from './RolePermissions.ValidationSchema';
import { toast } from 'react-toastify';
import { FormField } from '../../../../Components/FormField';
import SidebarField from '../../../../Components/SidebarField';
import TextInput from '../../../../Components/TextInput';
import SelectDropdown from '../../../../Components/Dropdown/SelectDropdown';
import Button from '../../../../Components/Button';
import MultiSelectDropDown from '../../../../Components/Dropdown/MultiSelectDropDown';
import { ComponentTypeApi, PermissionApi } from '../../../../App/api/role_and_permissions.api';
import { useFetchAll } from '../../../../custom/FetchApiHook';
import { ComponentTypeSchema } from './ValidationSchema';
import ToggleField from '../../../../Components/ToggleField';

function AddComponentTypes({ currentItems, getAllData, open, handleClose }) {

  const permissionsData= useFetchAll(() => PermissionApi.getAllPermissionsData()); 

  // console.log("allPermissions",permissionsData?.value?.data);
  

  const initialValues = {
    name: currentItems?.name || '',
    // permissions: currentItems?.permissions || [],  
    active:currentItems?.active||false  
  };
  
  const handleSubmit = async (values, { resetForm }) => {
    // console.log("Data",values);
    
    try {
      // console.log('values', values);
      // Logic for creating or updating the role and permissions
      const response = currentItems?._id
        ? await ComponentTypeApi.updateComponentType(values, currentItems._id)
        : await ComponentTypeApi.createComponentType(values);

      getAllData();
      toast.success(currentItems?._id ? 'Component Type updated' : 'Component Type created');
    } catch (err) {
      console.error(err);
      toast.error(err?.message);
    } finally {
      resetForm();
      handleClose();
    }
  };

  





  if (open) {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          validationSchema={ComponentTypeSchema}
        >
          {({ handleChange, values, setFieldValue }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={handleClose}
                title={currentItems?._id ? 'Update Component Type' : 'Add New Component Type'}
                button1={<Button text="Cancel" type="button" onClick={handleClose} />}
                button2={<Button text={currentItems?._id ? 'Update' : 'Submit'} type="submit" />}
              >
                <FormField label="Component Type" tooltip="Enter Component Type name">                    
                     <TextInput
                      name="name"
                      type="text"
                      value={values.name}
                      placeholder="Component Type"
                      onChange={handleChange}
                      className="outline-none capitalize"
                      required={true}
                    />
                  <ErrorMessage name="name" component="p" className="error" />
                </FormField>                
                {/* <FormField label="Permissions" tooltip="Choose permissions">                   
                     <MultiSelectDropDown
                        sx={{ width: '100%' }} // Optional custom style
                        name={`permissions`}
                        value={values.permissions}
                        options={permissionsData?.value?.data?.map((item)=>{
                          return {permissionId:item._id,permissionName:item.name}
                        })||[]}
                        placeholder="Select options"
                        handleMultiselectChange={(e)=>{
                            console.log(e);
                            setFieldValue('permissions',e)
                            
                        }}
                        optionLabel="permissionName"
                        // optionValue="_id"
                        required={true}
                    />
                  <ErrorMessage name="permissions" component="p" className="error" />
                </FormField>  */}
                <div>
                <ToggleField
                  text={values.active?"Enabled":'Disabled'}
                  name="active"
                  value={values.active}
                  toggaleHandleChange={(e)=>{
                    // console.log("v",e.target.value);
                    
                    setFieldValue('active',e.target.value)
                  }}
                />    
                 <ErrorMessage name="active" component="p" className="error" />
                </div>    
              </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
  return null;
}

export default AddComponentTypes;
